const hasProperty = (obj, key) => {
    return obj.hasOwnProperty(key);
  };
  
  const listHasData = (list) => {
    return list && list.length > 0;
  };

  export const objectsHelper = {
    hasProperty,
    listHasData
  };
  